import React from "react";
import { MDBContainer, MDBIcon } from "mdb-react-ui-kit";
import medicalspeciality from "../img/Oursolutions/medical specialist 2.jpg";
import ambulatory from "../img/Oursolutions/Ambulatory.jpg";
import medicalspecialitygroup from "../img/Oursolutions/multi speciality 2.jpg";
import hospital from "../img/Oursolutions/hospital 1.jpg";
import lab from "../img/Oursolutions/lab 1.jpg";
import IT from "../img/Oursolutions/health it.jpg";
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function ConsultancyDesc() {
  const ref = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Parse the URL parameter to get the contentId
    const searchParams = new URLSearchParams(location.search);
    const contentId = searchParams.get('contentId');
    const contentId1 = searchParams.get('contentId1');
    const contentId2 = searchParams.get('contentId2');
    const contentId3 = searchParams.get('contentId3');
    const contentId4 = searchParams.get('contentId4');
    const contentId5 = searchParams.get('contentId5');

    // Find the element with the specified contentId and scroll to it.
    const targetElement = document.getElementById(contentId);
    const targetElement1 = document.getElementById(contentId1);
    const targetElement2 = document.getElementById(contentId2);
    const targetElement3 = document.getElementById(contentId3);
    const targetElement4 = document.getElementById(contentId4);
    const targetElement5 = document.getElementById(contentId5);
    if (targetElement) {
      // Calculate the scroll position to show the entire content div
      const yOffset = -100; // Adjust this value as needed
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      const scrollToPosition = targetPosition + yOffset;

      // Scroll to the calculated position
      window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
    }
    if (targetElement1) {

      const yOffset1 = -100; // Adjust this value as needed
      const targetPosition1 = targetElement1.getBoundingClientRect().top + window.scrollY;
      const scrollToPosition1 = targetPosition1 + yOffset1;

      // Scroll to the calculated position
      window.scrollTo({ top: scrollToPosition1, behavior: 'smooth' });
    }
    if (targetElement2) {
      const yOffset2 = -100; // Adjust this value as needed
      const targetPosition2 = targetElement2.getBoundingClientRect().top + window.scrollY;
      const scrollToPosition2 = targetPosition2 + yOffset2;

      // Scroll to the calculated position
      window.scrollTo({ top: scrollToPosition2, behavior: 'smooth' });
    }
    if (targetElement3) {
      const yOffset3 = -100; // Adjust this value as needed
      const targetPosition3 = targetElement3.getBoundingClientRect().top + window.scrollY;
      const scrollToPosition3 = targetPosition3 + yOffset3;

      // Scroll to the calculated position
      window.scrollTo({ top: scrollToPosition3, behavior: 'smooth' });
    }
    if (targetElement4) {
      const yOffset4 = -100; // Adjust this value as needed
      const targetPosition4 = targetElement4.getBoundingClientRect().top + window.scrollY;
      const scrollToPosition4 = targetPosition4 + yOffset4;

      // Scroll to the calculated position
      window.scrollTo({ top: scrollToPosition4, behavior: 'smooth' });
    }
    if (targetElement5) {
      const yOffset5 = -100; // Adjust this value as needed
      const targetPosition5 = targetElement5.getBoundingClientRect().top + window.scrollY;
      const scrollToPosition5 = targetPosition5 + yOffset5;

      // Scroll to the calculated position
      window.scrollTo({ top: scrollToPosition5, behavior: 'smooth' });
    }
  }, [location.search]);

  return (
    <MDBContainer fluid className="p-0 bg-light">
      <div className="container py-5">
        <div className="row">

          <div className="col-12">
            <div className="section-title mb-4 pb-2">
              <h1 className="title mb-4 mt-4 display-heading AcerhealthTextPurple text-center fomtsizetest" style={{ fontFamily: 'Lora, serif' }}>Medical Billing Specialities</h1>
            </div>
          </div>
          <div className="card p-4">
            <div className="col-lg-12 mb-5">
              <div id="myUniqueContent" ref={ref}>
                <div className="row">
                  <div className="col-md-8">
                    <h2 className="title AcerhealthTextPurple fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                      Medical Specialists
                    </h2>
                    <hr style={{ border: "2px Solid #582C83" }}></hr>
                    <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: 'justify' }}>
                      <b> AcerHealth </b>offers expert <b>medical billing services </b>designed to manage the complexities of billing and claims processing across various specialties. Our team not only handles
                      coding challenges and unique documentation requirements, but also understands the specific billing issues that come with each medical specialty.
                      <a
                        href="https://acerhealth.com/Cardologyspeciality"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                      >
                        Medical specialists
                      </a>
                      are the backbone of modern healthcare, providing focused, competent care in their fields, and our billing expertise ensures they can concentrate on patient needs without administrative distractions. By supporting specialized providers, we help streamline revenue cycle management, improve denial rate reduction, and enhance the efficiency of
                      <a
                        href="https://acerhealth.com/services/medical-billing-and-credentialing"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                      >
                        medical billing outsourcing
                      </a> —ensuring accuracy, compliance, and faster reimbursements.
                    </p>
                  </div>
                  <div className="col-md-4 text-end" width={50}>
                    <img src={medicalspeciality} className="img-fluid" width={350} height={250} alt="Medical Billing Experts" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mb-5 d-none d-md-block" id="myUniqueContent1" ref={ref1}>
              <div className="row">
                <div className="col-md-4 text-start" width={50}>
                  <img src={ambulatory} className="img-fluid" width={350} height={250} alt="Healthcare Credentialing Service" />
                </div>
                <div className="col-md-8">
                  <h2 className="title AcerhealthTextPurple fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    Ambulatory Surgery Centers
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{
                      fontSize: '18px',
                      fontFamily: 'Alegreya Sans',
                      fontWeight: '500',
                      lineHeight: '1.5',
                      textAlign: 'justify'
                    }}
                  >
                    We provide specialized medical billing services for <b>
                      Ambulatory Surgery Centers (ASCs),</b> which differ from regular hospital settings by focusing exclusively on same-day surgeries that
                    don’t require overnight stays. This model helps reduce financial burdens on patients while improving the efficiency of healthcare delivery. ASCs operate within a distinct billing framework that
                    requires specialized expertise to manage accurately. As a trusted <b>medical billing company,</b> AcerHealth offers tailored solutions for ASC billing, supporting precise coding, compliance, and faster reimbursements.
                    Our services strengthen revenue cycle management, assist with denial rate reduction, and make us a valuable partner for hospitals and surgery centers seeking to optimize their financial operations.
                  </p>

                </div>
              </div>
            </div>
            <div className="col-lg-12 mb-5 d-md-none">
              <div id="myUniqueContent" ref={ref}>
                <div className="row">
                  <div className="col-md-8">
                    <h2 className="title AcerhealthTextPurple fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                      Ambulatory Surgery Centers
                    </h2>
                    <hr style={{ border: "2px Solid #582C83" }}></hr>
                    <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                      AcerHealth Ambulatory Surgery Centers differentiate themselves from regular hospital settings by specializing solely in same day surgeries that do not necessitate overnight stays. This not only decreases the financial burden on patients but it also contributes to overall healthcare delivery efficiency. Ambulatory Surgery Centers operate inside a different billing system that necessitates specialized knowledge to navigate properly. AcerHealth is a trustworthy medical billing agency that specializes in Ambulatory Surgery Centers billing and it becomes a beneficial partner for hospitals.
                    </p>
                  </div>

                  {/* Mobile view: Display image after content */}
                  <div className="col-md-4 text-end" width={50}>
                    <img src={ambulatory} className="img-fluid" width={350} height={250} alt="Medical Billing Experts" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mb-5" id="myUniqueContent2" ref={ref2}>
              <div className="row">
                <div className="col-md-8">
                  <h2 className="title AcerhealthTextPurple fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    Multi-Specialty Groups
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: 'justify', }}>
                    AcerHealth supports <b>multi-specialty medical groups </b>that serve as trusted providers of comprehensive, integrated healthcare. These groups
                    bring together medical professionals from various specialties under one roof, fostering collaboration, enhancing patient care, and improving
                    operational efficiency. Managing billing for multi-specialty groups presents unique challenges and opportunities that require a specialized
                    approach to medical billing services and revenue cycle management. With deep expertise in this area, AcerHealth helps streamline complex billing
                    processes, reduce errors, and optimize financial performance—offering holistic solutions that strengthen <b>medical billing outsourcing </b>and support
                    reliable, compliant reimbursement for multi-specialty practices.                </p>
                </div>
                <div className="col-md-4 p-4 text-end" width={50}>
                  <img src={medicalspecialitygroup} className="img-fluid" width={350} height={250} alt="Multi Speciality Group " />
                </div>
              </div>
            </div>
            <div className="col-lg-12 mb-5 d-none d-md-block" id="myUniqueContent3" ref={ref3}>
              <div className="row">
                <div className="col-md-4 text-start p-2" width={50}>
                  <img src={hospital} className="img-fluid" width={350} height={250} alt="Hospital Centers" />
                </div>
                <div className="col-md-8">
                  <h2 className="title AcerhealthTextPurple fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    Hospital Centers
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{
                      fontSize: '18px',
                      fontFamily: 'Alegreya Sans',
                      fontWeight: '500',
                      textAlign: 'justify',
                      lineHeight: '1.6'
                    }}
                  >
                    Hospitals remain pillars of medical excellence in today’s evolving healthcare landscape, delivering a wide range of care from
                    routine checkups to critical, life-saving procedures. <b>AcerHealth</b> is a trusted provider of medical billing services, specializing
                    in supporting hospitals by managing the complex financial processes that keep their operations running smoothly.

                    This allows hospital teams to focus on delivering exceptional patient care while we handle billing, compliance, and reimbursement tasks.
                    With expertise across diverse hospital settings—including emergency rooms, operating rooms, inpatient care, and specialty units—our solutions
                    strengthen revenue cycle management, reduce denials, and enhance medical billing outsourcing efficiency for hospitals of all sizes.
                  </p>

                </div>
              </div>
            </div>
            <div className="col-lg-12 mb-5 d-md-none">
              <div id="myUniqueContent" ref={ref}>
                <div className="row">
                  <div className="col-md-8">
                    <h2 className="title AcerhealthTextPurple fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                      Hospital Centers
                    </h2>
                    <hr style={{ border: "2px Solid #582C83" }}></hr>
                    <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                      Hospitals remain as a pillar of medical excellence in the ever-changing healthcare sector, offering a broad spectrum of care, ranging from routine checkups to life-saving procedures. AcerHealth is a recognized specialist in medical billing. We play a key part in ensuring that hospitals can concentrate on providing excellent patient care while our professional team expertly handle the various financial processes that support their operations. Medical services are offered in hospitals in a variety of settings. The range of medical interventions is broad and diverse, encompassing everything from emergency rooms and operating rooms to inpatient care and specialty hospitals. AcerHealth caters to all such services.
                    </p>
                  </div>

                  {/* Mobile view: Display image after content */}
                  <div className="col-md-4 text-end" width={50}>
                    <img src={hospital} className="img-fluid" width={350} height={250} alt="Medical Billing Experts" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mb-5" id="myUniqueContent4" ref={ref4}>
              <div className="row">
                <div className="col-md-8">
                  <h2 className="title AcerhealthTextPurple fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    Laboratories
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{
                      fontSize: '18px',
                      fontFamily: 'Alegreya Sans',
                      fontWeight: '500',
                      textAlign: 'justify',
                      lineHeight: '1.6'
                    }}
                  >
                    Laboratories play a crucial role in modern healthcare by providing essential diagnostic evidence that guides treatment strategies and medical decisions.
                    Focused on delivering accurate and timely test results, labs operate within a complex environment that demands specialized billing expertise.
                    <b>AcerHealth</b> is a trusted partner in this space, offering tailored
                    <a
                      href="https://www.acerhealth.com/services/medical-billing-services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#007BFF', textDecoration: 'none', margin: '0 5px' }}
                    >
                      medical billing services
                    </a>
                    for laboratories that handle everything from routine blood tests to advanced genetic testing. This diversity requires a deep understanding of CPT codes,
                    medical necessity guidelines, insurance rules, and compliance standards.

                    Our solutions help labs navigate these complexities, strengthening
                    <a
                      href="https://acerhealth.com/services/revenue-cycle-management"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#007BFF', textDecoration: 'none', margin: '0 5px' }}
                    >
                      revenue cycle management,
                    </a>
                    reducing denials, and enhancing the performance of medical billing outsourcing for diagnostic services.
                  </p>

                </div>
                <div className="col-md-4 text-end p-3" width={50}>
                  <img src={lab} className="img-fluid" width={350} height={250} alt="Laboratories" />
                </div>
              </div>
            </div>
            <div className="col-lg-12 mb-5  d-none d-md-block" id="myUniqueContent5" ref={ref5}>
              <div className="row">
                <div className="col-md-4 text-start p-2" width={50}>
                  <img src={IT} className="img-fluid" width={350} height={250} alt="Health IT" />
                </div>
                <div className="col-md-8">
                  <h2 className="title AcerhealthTextPurple fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    Health IT
                  </h2>
                  <hr style={{ border: "2px Solid #582C83" }}></hr>
                  <p
                    className="mt-3 mb-0 justify-content-left"
                    style={{
                      fontSize: '18px',
                      fontFamily: 'Alegreya Sans',
                      fontWeight: '500',
                      textAlign: 'justify',
                      lineHeight: '1.6'
                    }}
                  >
                    In today’s digital healthcare environment, <b>health information technology (Health IT)</b> is transforming how medical practices operate,
                    manage data, and deliver patient care. Health IT serves as the foundation of clarity, efficiency, and seamless collaboration that
                    supports the most
                    <a
                      href="https://acerhealth.com/blog/medical-billing-techniques"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#007BFF', textDecoration: 'none', margin: '0 5px' }}
                    >
                      effective medical billing services.
                    </a>
                    This term encompasses a wide range of tools and systems designed to improve the
                    collection, storage, sharing, and analysis of health-related data.

                    In the context of medical billing, Health IT is essential for optimizing workflows, reducing errors, ensuring compliance,
                    and enhancing overall financial performance. By integrating advanced technology, AcerHealth helps practices strengthen revenue cycle management,
                    reduce denials, and improve the efficiency of medical billing outsourcing operations.
                  </p>

                </div>
              </div>
            </div>
            <div className="col-lg-12 mb-5 d-md-none">
              <div id="myUniqueContent" ref={ref}>
                <div className="row">
                  <div className="col-md-8">
                    <h2 className="title AcerhealthTextPurple fontsizeset2" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                      Health IT
                    </h2>
                    <hr style={{ border: "2px Solid #582C83" }}></hr>
                    <p className="mt-3 mb-0 justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                      In the digital era of healthcare, health information technology is changing how medical practices run, handle data, and treat patients. The health IT is the cornerstone of clarity, efficiency, and seamless collaboration that underpins the best medical billing systems. The term "Health IT" refers to a broad range of tools and systems created to improve the gathering, archiving, sharing, and analysis of health-related data. It is also essential for optimizing workflows, lowering errors, maintaining compliance, and enhancing overall financial performance in the field of medical billing.
                    </p>
                  </div>

                  {/* Mobile view: Display image after content */}
                  <div className="col-md-4 text-end" width={50}>
                    <img src={IT} className="img-fluid" width={350} height={250} alt="Medical Billing Experts" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
}
